module.exports = __webpack_public_path__ + "media/images/flags/32/Bangladesh-8027425808474934a0dece11ee114f6f.png";